export const NOAA = {
  title: {
    value: 'NOAA CFSv2',
  },
  paragraph: {
    value: `The data set from NOAA CFSv2 (Climate Forecast system Version 2) include a selection of global-scale meteorological data variables. The Climate Forecast System Version 2 (CFSv2) produced by the NOAA National Centers for Environmental Prediction (NCEP) is a fully coupled model representing the interaction between the Earth's oceans, land and atmosphere.`,
  },
  table: {
    value: {
      header: ['General', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          General: 'Title',
          Model: 'Climate Forecast System Version 2 (CFSv2) Operational Forecasts (from NOAA).',
        },
        {
          General: 'Geographical Coverage',
          Model: 'Global',
        },
        {
          General: 'Category',
          Model: 'Meteorological Parameters',
        },
        {
          General: 'Source Name',
          Model: `NCEP Climate Forecast System Version 2 (CFSv2), Selected Hourly Timeseries Products`,
        },
        {
          General: 'Publisher',
          Model: 'NOAA, NCEP (National Centers for Environment Prediction)',
        },
        {
          General: 'Cost (ex. VAT)',
          Model: 'Free',
        },
        {
          General: 'Typical Applications',
          Model: 'Wind, Wave, Hydrodynamic, Offshore and Marine projects',
        },
        {
          General: 'References',
          Model: `Climate Forecast System (CFS) | National Centers for Environmental Information (NCEI) (noaa.gov): ***https://www.ncei.noaa.gov/products/weather-climate-models/climate-forecast-system*** CFSv2 dataset description: ***https://data.nodc.noaa.gov/cgi-bin/iso?id=gov.noaa.ncdc:C00877***`,
        },
      ],
    },
  },
  table1: {
    value: {
      header: ['Coverage', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          Coverage: 'Geographical Range',
          Model: `Global:
                  Longitude: -180°W to 180°E 
                  Latitude: -90°S to 90°N`,
        },
        {
          Coverage: 'Geographical Resolution',
          Model: `Data variables resolutions (quadratic grid cells):
                  Relative humidity and Air pressure: 1.0 deg.                  
                  Other items available : 0.2 degree`,
        },
        {
          Coverage: 'Vertical Reference',
          Model: 'Sea Surface',
        },
        {
          Coverage: 'Vertical Range',
          Model: '-',
        },
        {
          Coverage: 'Vertical Resolution',
          Model: '-',
        },
        {
          Coverage: 'Temporal Reference',
          Model: 'UTC',
        },
        {
          Coverage: 'Temporal Range',
          Model: `Data Link coverage:
                  1/1-2016 -> Present`,
        },
        {
          Coverage: 'Temporal Resolution',
          Model: '1 hour',
        },
      ],
    },
  },
  table2: {
    value: {
      header: ['Variables', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          Variables: 'Name (Unit)',
          Model: `Air Temperature at 2m [Deg. C.]
                  Air Pressure at Mean Sea Level [hPa]
                  Wind velocity components (U & V) at 10m, [m/s]
                  Relative humidity [%]
                  Precipitation rate [mm/day]
                  Cloud cover  [%]
                  Downward Short-Wave Radiation [W/m^2]
                  Ice Concentration [%]
          `,
        },
      ],
    },
  },
  table3: {
    value: {
      header: ['Credits', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          Credits: 'Cited Authors and Originators',
          Model: `DOC/NOAA/NWS/NCEP > National Centers for Environmental Prediction, National Weather Service, NOAA, U.S. Department of Commerce`,
        },
        {
          Credits: 'Publishers',
          Model: `NOAA National Centers for Environmental Information
                 
          DOC/NOAA/NESDIS/NCDC > National Climatic Data Center, NESDIS, NOAA, U.S. Department of Commerce
          `,
        },
      ],
    },
  },
};
